export const scoreLabelMappingThai = {
  // Harmful
    'Bacillus genus': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
    'Candida albicans': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
      'Clostridium difficile': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
      'Escherichia coli': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
      'Staphylococcus aureus': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
  'Clostridioides difficile': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
  },
  'Blautia genus': {
    3: 'ปกติ',
    4: 'มากกว่าปกติเล็กน้อย',
    5: 'สูงกว่าปกติ'
    },
    'Firmicutes phylum': {
        3: 'ปกติ',
        4: 'มากกว่าปกติเล็กน้อย',
        5: 'สูงกว่าปกติ'
    },
    'Ruminococcus obeum': {
        3: 'ปกติ',
        4: 'มากกว่าปกติเล็กน้อย',
        5: 'สูงกว่าปกติ'
    },
    'Ruminococcus bromii': {
        3: 'ปกติ',
        4: 'มากกว่าปกติเล็กน้อย',
        5: 'สูงกว่าปกติ'
    },

  // Core Bac.
    'Akkermansia muciniphila': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Alistipes putredinis': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Bacteroides genus': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Bacteroides fragilis': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Faecalibacterium prausnitzii': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    // 'Ruminococcus bromii': {
    //     1: 'ต่ำกว่าปกติ',
    //     2: 'ต่ำกว่าปกติเล็กน้อย',
    //     3: 'ปกติ'
    //   },
    'Roseburia hominis': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Ruminococcus genus': {
        1: 'ต่ำกว่าปกติ',
        2: 'ต่ำกว่าปกติเล็กน้อย',
        3: 'ปกติ'
    },
    'Enterococcus genus': {
        1: 'ต่ำกว่าปกติ',
        2: 'ต่ำกว่าปกติเล็กน้อย',
        3: 'ปกติ'
    },
    'Clostridium cluster IV': {
        1: 'ต่ำกว่าปกติ',
        2: 'ต่ำกว่าปกติเล็กน้อย',
        3: 'ปกติ'
    },
    'Bacteroidetes genus': {
        1: 'ต่ำกว่าปกติ',
        2: 'ต่ำกว่าปกติเล็กน้อย',
        3: 'ปกติ'
    },
    'Bacteroidetes phylum': {
        1: 'ต่ำกว่าปกติ',
        2: 'ต่ำกว่าปกติเล็กน้อย',
        3: 'ปกติ'
    },

  // Probiotic
    'Bifidobacterium bifidum': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Bifidobacterium breve': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Bifidobacterium lactis': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Bifidobacterium longum': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus acidophilus': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus gasseri': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus helveticus': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus paracasei': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus plantarum': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus reuteri': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Lactobacillus rhamnosus': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
    'Streptococcus thermophilus': {
      1: 'ต่ำกว่าปกติ',
      2: 'ต่ำกว่าปกติเล็กน้อย',
      3: 'ปกติ'
    },
  };
  
export const scoreLabelPositionThai = [

    {
        label: 'Bacillus genus',
        page: 11,
        yOffset: 240,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 230,
        yResult: 230,
        yResulttext: 234,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 11,
        yOffset: 270,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 260,
        yResult: 260,
        yResulttext: 264,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 11,
        yOffset: 300,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 290,
        yResult: 290,
        yResulttext: 294,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 11,
        yOffset: 330,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 320,
        yResult: 320,
        yResulttext: 324,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 11,
        yOffset: 360,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 350,
        yResult: 350,
        yResulttext: 354,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 11,
        yOffset: 444,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 434,
        yResult: 434,
        yResulttext: 438,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 11,
        yOffset: 474,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 464,
        yResult: 464,
        yResulttext: 468,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 11,
        yOffset: 504,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 494,
        yResult: 494,
        yResulttext: 498,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 11,
        yOffset: 534,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 524,
        yResult: 524,
        yResulttext: 528,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 11,
        yOffset: 564,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 554,
        yResult: 554,
        yResulttext: 558,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 11,
        yOffset: 594,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 584,
        yResult: 584,
        yResulttext: 588,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 680,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 670,
        yResult: 670,
        yResulttext: 674,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 11,
        yOffset: 710,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 700,
        yResult: 700,
        yResulttext: 704,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 11,
        yOffset: 740,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 730,
        yResult: 730,
        yResulttext: 734,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 11,
        yOffset: 770,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 760,
        yResult: 760,
        yResulttext: 764,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 800,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 790,
        yResult: 790,
        yResulttext: 794,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 11,
        yOffset: 830,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 820,
        yResult: 820,
        yResulttext: 824,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus helveticus',
        page: 11,
        yOffset: 860,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 850,
        yResult: 850,
        yResulttext: 854,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 11,
        yOffset: 890,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 880,
        yResult: 880,
        yResulttext: 884,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 11,
        yOffset: 920,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 910,
        yResult: 910,
        yResulttext: 914,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 11,
        yOffset: 950,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 940,
        yResult: 940,
        yResulttext: 944,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 980,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 970,
        yResult: 970,
        yResulttext: 974,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Streptococcus thermophilus',
        page: 11,
        yOffset: 1010,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 1000,
        yResult: 1000,
        yResulttext: 1004,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacillus genus',
        page: 27,
        yOffset: 175,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 165,
        yResult: 434,
        yResulttext: 169,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bacillus genus',
        page: 32,
        yOffset: 170,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 160,
        yResult: 434,
        yResulttext: 164,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 17,
        yOffset: 558,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 548,
        yResult: 434,
        yResulttext: 552,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 27,
        yOffset: 214,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 204,
        yResult: 434,
        yResulttext: 208,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 32,
        yOffset: 209,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 199,
        yResult: 434,
        yResulttext: 203,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Clostridium difficile',
        page: 32,
        yOffset: 248,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 238,
        yResult: 434,
        yResulttext: 241,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 18,
        yOffset: 560,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 550,
        yResult: 434,
        yResulttext: 554,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Escherichia coli',
        page: 32,
        yOffset: 287,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 277,
        yResult: 434,
        yResulttext: 280,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 18,
        yOffset: 599,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 589,
        yResult: 434,
        yResulttext: 593,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 30,
        yOffset: 175,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 165,
        yResult: 434,
        yResulttext: 169,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 32,
        yOffset: 326,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 316,
        yResult: 434,
        yResulttext: 319,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 17,
        yOffset: 654,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 644,
        yResult: 434,
        yResulttext: 648,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 23,
        yOffset: 710,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 700,
        yResult: 434,
        yResulttext: 704,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 25,
        yOffset: 175,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 165,
        yResult: 434,
        yResulttext: 169,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 27,
        yOffset: 300,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 290,
        yResult: 434,
        yResulttext: 294,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 22,
        yOffset: 667,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 657,
        yResult: 434,
        yResulttext: 661,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 34,
        yOffset: 169,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 159,
        yResult: 434,
        yResulttext: 163,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 19,
        yOffset: 720,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 710,
        yResult: 434,
        yResulttext: 714,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 25,
        yOffset: 214,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 204,
        yResult: 434,
        yResulttext: 208,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 19,
        yOffset: 759,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 749,
        yResult: 434,
        yResulttext: 753,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 27,
        yOffset: 339,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 329,
        yResult: 434,
        yResulttext: 333,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 17,
        yOffset: 693,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 683,
        yResult: 434,
        yResulttext: 687,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 18,
        yOffset: 695,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 685,
        yResult: 434,
        yResulttext: 689,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 22,
        yOffset: 706,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 696,
        yResult: 434,
        yResulttext: 700,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 25,
        yOffset: 253,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 243,
        yResult: 434,
        yResulttext: 247,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 27,
        yOffset: 378,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 368,
        yResult: 434,
        yResulttext: 372,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 30,
        yOffset: 269,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 259,
        yResult: 434,
        yResulttext: 263,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 32,
        yOffset: 412,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 402,
        yResult: 434,
        yResulttext: 406,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 34,
        yOffset: 208,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 198,
        yResult: 434,
        yResulttext: 202,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 37,
        yOffset: 747,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 737,
        yResult: 434,
        yResulttext: 741,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium breve',
        page: 37,
        yOffset: 840,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 830,
        yResult: 434,
        yResulttext: 834,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 37,
        yOffset: 879,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 869,
        yResult: 434,
        yResulttext: 873,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus gasseri',
        page: 37,
        yOffset: 918,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 908,
        yResult: 434,
        yResulttext: 912,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 37,
        yOffset: 957,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 947,
        yResult: 434,
        yResulttext: 951,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 37,
        yOffset: 996,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 986,
        yResult: 434,
        yResulttext: 990,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Akkermansia muciniphila',
        page: 36,
        yOffset: 850,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 840,
        yResult: 434,
        yResulttext: 844,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 36,
        yOffset: 766,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 756,
        yResult: 434,
        yResulttext: 760,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium bifidum',
        page: 36,
        yOffset: 933,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 923,
        yResult: 434,
        yResulttext: 927,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus helveticus',
        page: 36,
        yOffset: 972,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 962,
        yResult: 434,
        yResulttext: 966,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 36,
        yOffset: 1011,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 1001,
        yResult: 434,
        yResulttext: 1005,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Roseburia hominis',
        page: 32,
        yOffset: 451,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 441,
        yResult: 434,
        yResulttext: 445,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 34,
        yOffset: 247,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 237,
        yResult: 434,
        yResulttext: 241,
        xResulttext: 565,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 17,
        yOffset: 784,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 774,
        yResult: 434,
        yResulttext: 778,
        xResulttext: 565,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 18,
        yOffset: 788,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 778,
        yResult: 434,
        yResulttext: 782,
        xResulttext: 565,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 19,
        yOffset: 853,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 843,
        yResult: 434,
        yResulttext: 847,
        xResulttext: 565,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 23,
        yOffset: 800,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 790,
        yResult: 434,
        yResulttext: 794,
        xResulttext: 565,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 25,
        yOffset: 342,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 332,
        yResult: 434,
        yResulttext: 336,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 16,
        yOffset: 565,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 555,
        yResult: 434,
        yResulttext: 559,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 17,
        yOffset: 823,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 813,
        yResult: 434,
        yResulttext: 817,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 18,
        yOffset: 827,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 817,
        yResult: 434,
        yResulttext: 821,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 19,
        yOffset: 892,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 882,
        yResult: 434,
        yResulttext: 886,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 25,
        yOffset: 381,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 371,
        yResult: 434,
        yResulttext: 375,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 34,
        yOffset: 334,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 324,
        yResult: 434,
        yResulttext: 328,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 16,
        yOffset: 604,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 594,
        yResult: 434,
        yResulttext: 598,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 22,
        yOffset: 800,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 790,
        yResult: 434,
        yResulttext: 794,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 30,
        yOffset: 360,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 350,
        yResult: 434,
        yResulttext: 354,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 16,
        yOffset: 643,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 633,
        yResult: 434,
        yResulttext: 637,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 19,
        yOffset: 931,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 921,
        yResult: 434,
        yResulttext: 925,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 25,
        yOffset: 420,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 410,
        yResult: 434,
        yResulttext: 414,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 27,
        yOffset: 464,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 454,
        yResult: 434,
        yResulttext: 458,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 30,
        yOffset: 399,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 389,
        yResult: 434,
        yResulttext: 393,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 34,
        yOffset: 373,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 363,
        yResult: 434,
        yResulttext: 367,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 16,
        yOffset: 682,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 671,
        yResult: 434,
        yResulttext: 675,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 18,
        yOffset: 866,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 856,
        yResult: 434,
        yResulttext: 860,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 22,
        yOffset: 839,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 829,
        yResult: 434,
        yResulttext: 833,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 23,
        yOffset: 839,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 829,
        yResult: 473,
        yResulttext: 833,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 25,
        yOffset: 459,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 449,
        yResult: 434,
        yResulttext: 453,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 30,
        yOffset: 438,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 428,
        yResult: 473,
        yResulttext: 432,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus gasseri',
        page: 25,
        yOffset: 498,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 488,
        yResult: 434,
        yResulttext: 492,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus gasseri',
        page: 27,
        yOffset: 503,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 493,
        yResult: 434,
        yResulttext: 497,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus helveticus',
        page: 34,
        yOffset: 412,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 402,
        yResult: 434,
        yResulttext: 406,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 16,
        yOffset: 721,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 710,
        yResult: 434,
        yResulttext: 714,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 22,
        yOffset: 878,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 868,
        yResult: 473,
        yResulttext: 872,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 23,
        yOffset: 878,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 868,
        yResult: 473,
        yResulttext: 872,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 30,
        yOffset: 477,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 467,
        yResult: 473,
        yResulttext: 471,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 34,
        yOffset: 451,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 441,
        yResult: 434,
        yResulttext: 445,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 16,
        yOffset: 760,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 749,
        yResult: 434,
        yResulttext: 753,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 17,
        yOffset: 862,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 852,
        yResult: 434,
        yResulttext: 856,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 19,
        yOffset: 970,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 960,
        yResult: 434,
        yResulttext: 964,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 23,
        yOffset: 917,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 907,
        yResult: 473,
        yResulttext: 911,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 25,
        yOffset: 537,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 527,
        yResult: 434,
        yResulttext: 531,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 27,
        yOffset: 542,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 532,
        yResult: 434,
        yResulttext: 536,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 30,
        yOffset: 516,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 506,
        yResult: 473,
        yResulttext: 510,
        xResulttext: 565,  
        show_result: false
    },  
    {
        label: 'Lactobacillus reuteri',
        page: 27,
        yOffset: 581,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 571,
        yResult: 434,
        yResulttext: 575,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus reuteri',
        page: 32,
        yOffset: 535,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 525,
        yResult: 434,
        yResulttext: 529,
        xResulttext: 565,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus rhamnosus',
        page: 18,
        yOffset: 905,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 895,
        yResult: 434,
        yResulttext: 899,
        xResulttext: 565,  
        show_result: false
    },     
    {
        label: 'Lactobacillus rhamnosus',
        page: 30,
        yOffset: 555,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 545,
        yResult: 473,
        yResulttext: 549,
        xResulttext: 565,  
        show_result: false
    },     
    {
        label: 'Lactobacillus rhamnosus',
        page: 32,
        yOffset: 574,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 564,
        yResult: 434,
        yResulttext: 568,
        xResulttext: 565,  
        show_result: false
    },     
    {
        label: 'Streptococcus thermophilus',
        page: 19,
        yOffset: 1009,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 999,
        yResult: 434,
        yResulttext: 1003,
        xResulttext: 565,  
        show_result: false
    },  
    {
        label: 'Streptococcus thermophilus',
        page: 32,
        yOffset: 613,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 603,
        yResult: 434,
        yResulttext: 607,
        xResulttext: 565,  
        show_result: false
    },  
    {
        label: 'Streptococcus thermophilus',
        page: 34,
        yOffset: 490,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 480,
        yResult: 434,
        yResulttext: 484,
        xResulttext: 565,  
        show_result: false
    },  


]